import { useEffect, useState } from "react"
import { useCustomQuery } from "./useCustomQuery"

const useLocations = () => {
  const [locations, setLocations] = useState([])
  const {
    data: locationResponse,
    isLoading,
    isError,
    isFetching,
  } = useCustomQuery(["location-all"], "location/all")

  useEffect(() => {
    if (locationResponse?.data) {
      setLocations(locationResponse.data)
    }
  }, [locationResponse])
  return {
    locations,
    isLoading,
    isError,
    isFetching,
    setLocations,
  }
}

export default useLocations
